import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Tab from '../../../../components/tabs/';
import ClickMore from '../../../../components/clickMore/';
import Live from './live/';
import NewsLine from './newsLine/';

class NewsLive extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        current: 0,
        selected: true,
        link: 'https://finance.ifeng.com/shanklist/1-64-/',
    };

    handleTabsChange = index => {
        this.setState({ current: index });
    };

    handleSelected = () => {
        const { selected } = this.state;

        this.setState({ selected: !selected });
    };

    /**
     * 渲染组件
     */
    render() {
        const { current, selected, link } = this.state;
        const { content } = this.props;

        const stockNews = content.stockNews;
        
        const zqywClient = content.zqywClient;

        const tempObj = {};

        const zqywClientData = zqywClient.reduce((preValue, item) => {
            
            // eslint-disable-next-line no-unused-expressions
            tempObj[item.commentUrl] ? '' : tempObj[item.commentUrl] = true && preValue.push(item);

            return preValue;

        }, []);

        const title = {
            id: '20043',
            type: 'struct',
            title: '要闻直播主标题',
            groupName: '正文',
            content: content.newsLiveTab,
        };

        const newsLiveTabLink = {
            id: '20044',
            type: 'struct',
            title: '要闻直播标题外链',
            groupName: '正文',
            content: content.newsLiveTabLink,
        };

        return (
            <div className={styles.news_live}>
                <Tab
                    current={current}
                    title={title}
                    newsLiveTabLink={newsLiveTabLink}
                    handleTabsChange={this.handleTabsChange}
                />
                <div style={{ display: current === 0 ? 'block' : 'none' }}>
                    <div className={styles.stock_news}>
                        {zqywClientData.slice(0, 12).map((item, index) => <NewsLine content={item} key={index} />)}
                    </div>
                </div>
                <div style={{ display: current === 0 ? 'none' : 'block' }}>
                    <Live
                        content={content.liveLogo}
                        current={current}
                        selected={selected}
                        handleSelected={this.handleSelected}
                    />
                    {zqywClientData.slice(0, 6).map((item, index) => <NewsLine content={item} key={index} />)}
                </div>
                <ClickMore link={link} />
            </div>
        );
    }
}

export default errorBoundary(NewsLive);
